module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user4-035bc66f0bcde330c09503229745f219.jpg";